// extracted by mini-css-extract-plugin
export default {"pagination":"CommentNewsPagination_pagination__5q7Iu"};